import React from "react";
import { useSelector } from "react-redux";
import FlockoutLanding from "./FlockoutLanding";
import FlockoutMap from "./FlockoutMap";

// The homepage is a full-screen map either way: members get the real one,
// everyone else gets the public one with the pitch on top.
function FlockoutHome() {
  const loggedIn = !!localStorage.getItem("access_token");
  const allowed = useSelector((state) => state.permissions.allowedCards.includes("skywatch"));
  const loaded = useSelector((state) => state.permissions.loaded);

  if (loggedIn && !loaded) return <div className="flockout" style={{ height: "100vh" }} />;
  return loggedIn && allowed ? <FlockoutMap /> : <FlockoutLanding />;
}

export default FlockoutHome;
